import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=13a3a81a&"
import script from "./TransferDialog.vue?vue&type=script&lang=ts&"
export * from "./TransferDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TransferDialog.vue?vue&type=style&index=0&id=13a3a81a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports